module.exports = __webpack_public_path__ + "img/web_price_premium.3128de85.png";